import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const H2 = styled.h2`
  font-weight: 500;
  font-size: 32px;
  line-height: 37px;
  ${customTextColor}
`;
